// extracted by mini-css-extract-plugin
export default {"root":"PromptInput_root__7UEEx","mark":"PromptInput_mark__+pAhx"};